package com.zq.webproject.model

import kotlinx.serialization.Serializable

/**
 * 收益记录数据模型
 */
@Serializable
data class IncomeRecord(
    val id: Int,                    // 收益记录ID
    val userId: Int,                // 用户ID
    val userName: String? = null,   // 用户名
    val superiorId: Int,            // 上级ID
    val orderId: Int,               // 订单ID
    val orderNo: String? = null,    // 订单号（可为空）
    val incomeAmount: Double,       // 收益金额
    val incomeDate: String          // 收益日期
)

/**
 * 收益记录响应模型
 */
@Serializable
data class IncomeRecordResponse(
    val code: Int? = null,              // 状态码
    val message: String? = null,        // 消息
    val data: List<IncomeRecord>? = null  // 收益记录列表
)